<template>
  <FaqCategoryForm />
</template>

<script>
import FaqCategoryForm from '@/layouts/components/form/FaqCategoryForm.vue'

export default {
  components: { FaqCategoryForm },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
